import BaseService from '@/services/BaseService';

class GoogleConfigService extends BaseService {
    getGoogleConfig = () => this.get('/get-google-config');

    addGoogleConfig = (data) => this.post('/add-google-config', data);
}

export default new GoogleConfigService();
